var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"print"}},[_c('img',{staticStyle:{"border":"none","object-fit":"contain","display":"block"},attrs:{"id":"printIframe","src":_vm.imgUrl,"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }